import { render, staticRenderFns } from "./index-webgis.vue?vue&type=template&id=f632a4a6&"
import script from "./index-webgis.vue?vue&type=script&lang=js&"
export * from "./index-webgis.vue?vue&type=script&lang=js&"
import style0 from "./index-webgis.vue?vue&type=style&index=0&id=f632a4a6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports